import { render, staticRenderFns } from "./InformationAboutStudentLeavingTable.vue?vue&type=template&id=2d9abf35&"
import script from "./InformationAboutStudentLeavingTable.vue?vue&type=script&lang=js&"
export * from "./InformationAboutStudentLeavingTable.vue?vue&type=script&lang=js&"
import style0 from "./InformationAboutStudentLeavingTable.vue?vue&type=style&index=0&id=2d9abf35&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports